module.exports = __webpack_public_path__ + "static/mstile-310x150-7cc5b34bc4badb524cef68802e91f202.png";